import { all, call, put, select, take } from 'redux-saga/effects';
import { requestHandler } from '../fetcher.saga';
import { setTimeslotRules } from './actions';
import {
	SAVE_TIMESLOT_RULES,
	SAVE_TIMESLOT_RULES_BULK,
	RECEIVE_TIMESLOT_RULES,
	SAVE_TIMESLOTS,
	RECEIVE_TIMESLOTS,
	RECEIVE_TIMESLOT_ENABLED,
} from './types';

// POST la totalité des rules (chemin classique)
function* postRules(rules) {
	const { result } = yield call(
		requestHandler,
		'export',
		'POST',
		{ rules },
		'timeslot/rules'
	);
	if (result) {
		yield put({ type: RECEIVE_TIMESLOT_RULES, rules: result });
	}
}

function* saveTimeslotRules() {
	while (true) {
		const { entityType, id, rules } = yield take(SAVE_TIMESLOT_RULES);

		// on met à jour le store (merge de la section/produit dans la totalité des rules)
		yield put(setTimeslotRules({ type: entityType, id, rules }));

		// on récupère la totalité des rules à envoyer
		const { service } = yield select();
		const timeslot = service.timeslot || {};

		yield call(postRules, timeslot.rules || []);
	}
}

// Applique les mêmes rules à plusieurs produits : merge chaque produit dans le
// store puis POST la totalité des rules en une seule requête.
function* saveTimeslotRulesBulk() {
	while (true) {
		const { ids = [], rules } = yield take(SAVE_TIMESLOT_RULES_BULK);

		for (let i = 0; i < ids.length; i++) {
			yield put(setTimeslotRules({ type: 'product', id: ids[i], rules }));
		}

		const { service } = yield select();
		const timeslot = service.timeslot || {};

		yield call(postRules, timeslot.rules || []);
	}
}

// Persiste le draft global (enabled + timeslots) transmis par le composant.
// Le store n'est mis à jour qu'ici, une fois le back confirmé.
function* saveTimeslots() {
	while (true) {
		const { enabled, timeslotPos, timeslots } = yield take(SAVE_TIMESLOTS);

		// persiste l'activation/désactivation globale des créneaux + la synchro caisse
		yield call(
			requestHandler,
			'export',
			'POST',
			{ enabled, timeslot_pos: timeslotPos },
			'timeslot/enabled'
		);
		yield put({
			type: RECEIVE_TIMESLOT_ENABLED,
			enabled,
			timeslot_pos: timeslotPos,
		});

		const { result } = yield call(
			requestHandler,
			'export',
			'POST',
			{ timeslots: timeslots || [] },
			'timeslot'
		);

		// le back renvoie uniquement les timeslots à jour
		if (result) {
			yield put({ type: RECEIVE_TIMESLOTS, timeslots: result });

			// purge des rules devenues orphelines (timeslot supprimé)
			const validIds = result.map(ts => ts.id);
			const { service } = yield select();
			const currentRules = (service.timeslot || {}).rules || [];
			const filteredRules = currentRules.filter(rule =>
				validIds.includes(rule.idTimeslot)
			);

			if (filteredRules.length !== currentRules.length) {
				yield call(postRules, filteredRules);
			}
		}
	}
}

export default function* timeslotSaga() {
	yield all([saveTimeslotRules(), saveTimeslotRulesBulk(), saveTimeslots()]);
}
